import { createContext, ReactNode, useContext } from 'react';

interface ReportEditing {
  /** true when the reader may not change anything: a supplier, or a published version */
  readOnly: boolean;
}

const ReportEditingContext = createContext<ReportEditing>({ readOnly: true });

export function ReportEditingProvider({ readOnly, children }: { readOnly: boolean; children: ReactNode }) {
  return <ReportEditingContext.Provider value={{ readOnly }}>{children}</ReportEditingContext.Provider>;
}

export function useReportEditing(): ReportEditing {
  return useContext(ReportEditingContext);
}
